export class QuoteEmail {
  constructor(
    private to = "",
    private cc = "",
    private bcc = "",
    private subject = "",
    private message = "",
    private attachments = [],
    private messageId: string = null,
    private receivedAt: string = null,
  ) {}

  public getTo(): string {
    return this.to;
  }

  public getCc(): string {
    return this.cc;
  }

  public getBcc(): string {
    return this.bcc;
  }

  public getSubject(): string {
    return this.subject;
  }

  public getMessage(): string {
    return this.message;
  }

  public getAttachments() {
    return this.attachments;
  }

  public getMessageId(): string {
    return this.messageId;
  }

  public setMessageId(id: string): void {
    this.messageId = id;
  }

  public getReceivedAt(): string {
    return this.receivedAt;
  }

  public setReceivedAt(receivedAt: string): void {
    this.receivedAt = receivedAt;
  }

  public setField(fieldKey: string, val: string): void {
    this[fieldKey] = val;
  }
}
